import React from 'react';
import styles from './index.less';
const MessageQuestionGuide = props => {
  const { data = {} } = props;
  const { content = {} } = data;
  const { title, questions = [] } = content;

  return (
    <div className={styles[`question-guide-card`]}>
      <h3 className={styles[`card-title`]}>{title || '问题引导卡片标题'}</h3>
      <ul className={styles[`question-list`]}>
        {questions.map((question, index) => (
          <li key={index} className={styles[`question-item`]}>
            {`${index + 1}. ${question}`}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MessageQuestionGuide;
